// Pantalla de fin de partida (usa el ModalManager para mostrarse).
import { avatarHTML } from './ProfileUI.js';

export class ResultsScreen {
  constructor(modalManager) {
    this.modals = modalManager;
  }

  show(summary, { xpGained, isHumanWinner, selfId, onRematch, onHub }) {
    const ranked = [...summary.players].sort((a, b) => b.score - a.score);
    const winner = ranked[0] || { name: summary.winnerName || '—' };
    const medals = ['🥇', '🥈', '🥉'];
    const selfIdx = ranked.findIndex((p) => p.id === selfId);
    const selfScore = (selfIdx >= 0 ? ranked[selfIdx].score : 0) || 0;
    const selfRank = selfIdx >= 0 ? selfIdx + 1 : ranked.length;

    const rankRows = ranked.map((p, i) => `
      <div class="rs2-row ${p.id === summary.winnerId ? 'is-win' : ''} ${p.id === selfId ? 'is-self' : ''}">
        <span class="rs2-pos">${medals[i] || `${i + 1}º`}</span>
        <span class="rs2-ava-sm">${avatarHTML(p)}</span>
        <span class="rs2-nm">${p.name}${p.id === selfId ? '<i>TÚ</i>' : ''}</span>
        <span class="rs2-sc">${p.score}</span>
      </div>`).join('');

    const bestEvo = summary.bestEvolution
      ? `${summary.bestEvolution.from.toUpperCase()} → ${summary.bestEvolution.to.toUpperCase()}`
      : '—';
    const stats = [
      ['🔤', (summary.longestWord || '—').toUpperCase(), 'Palabra más larga'],
      ['🧬', bestEvo, 'Mejor evolución'],
      ['🔥', summary.maxCombo, 'Mayor combo'],
      ['📝', summary.totalWords, 'Palabras creadas'],
    ].map(([ic, val, label]) => `
      <div class="rs2-stat"><span class="rs2-stat-ic">${ic}</span><b class="rs2-stat-v">${val}</b><span class="rs2-stat-l">${label}</span></div>`).join('');

    const body = `
      <div class="rs2 ${isHumanWinner ? 'win' : 'lose'}">
        <div class="rs2-hero">
          ${isHumanWinner ? '<div class="rs2-glow"></div>' : ''}
          <div class="rs2-ava-wrap">
            ${isHumanWinner ? '<span class="rs2-crown">👑</span>' : ''}
            <span class="rs2-ava">${avatarHTML(winner)}</span>
          </div>
          <div class="rs2-title">${isHumanWinner ? '¡VICTORIA!' : 'DERROTA'}</div>
          <div class="rs2-sub">${isHumanWinner ? '¡Enhorabuena!' : `Gana ${winner.name}`}</div>
          <div class="rs2-score"><b>${selfScore}</b><span>Tus puntos · ${selfRank}º puesto</span></div>
          <div class="rs2-xp">✨ +${xpGained} XP</div>
        </div>
        <div class="rs2-info">
          <div class="rs2-rank">${rankRows}</div>
          <div class="rs2-divider"></div>
          <div class="rs2-stats">${stats}</div>
        </div>
      </div>`;

    const modal = this.modals.open({
      className: 'results-modal results-clean',
      dismissible: false,
      bodyHTML: body,
    });
    // Volver = círculo con X arriba a la derecha (como el resto de ventanas).
    const closeBtn = document.createElement('button');
    closeBtn.className = 'modal-close';
    closeBtn.setAttribute('aria-label', 'Volver');
    closeBtn.innerHTML = '✕';
    closeBtn.addEventListener('click', () => { this.modals.close(); onHub?.(); });
    modal.appendChild(closeBtn);
    // Revancha = círculo con ▶ abajo a la derecha (solo si aplica; en online no hay revancha).
    if (onRematch) {
      const rematchBtn = document.createElement('button');
      rematchBtn.className = 'lobby-start';
      rematchBtn.setAttribute('aria-label', 'Revancha');
      rematchBtn.innerHTML = '▶';
      rematchBtn.addEventListener('click', () => { this.modals.close(); onRematch(); });
      modal.appendChild(rematchBtn);
    }
  }
}
